// extracted by mini-css-extract-plugin
module.exports =  {"root":"EwtAQxMMe0IDHfLKgqAM"};